<template>
    <div>
        <MyHeader />

        <div class="container mb-5" style="margin-top: 90px">
            <div class="row justify-content-center">
                <div class="col-lg-8 col-md-6 col-xs-12 col-sm-12 bg-white rounded p-5 border mt-5">
                    <form @submit.prevent="addStatement()" class="row g-3" ref="statement_form">
                        <div class="col-md-6">
                            <div class="form-group mb-3">
                                <label for="overhead_number">ზედნადების ნომერი</label>
                                <input type="text" v-model="formData.overhead_number" id="overhead_number" class="form-control">
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group mb-3">
                                <label for="overhead_date">ზედნადების თარიღი</label>
                                <flat-pickr class="form-control" id="datetime-picker" v-model="formData.overhead_date" :config="flatpickrOptions"></flat-pickr>
                            </div>
                        </div>
                        <div class="col-md-12">
                            <div class="form-group mb-3">
                                <label for="store_address">მაღაზიის მისამართი</label>
                                <input type="text" v-model="formData.store_address" id="store_address" class="form-control">
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group mb-3">
                                <label for="beneficiary_name">აგრობარათის მფლობელი</label>
                                <input type="text" v-model="formData.beneficiary_name" id="beneficiary_name" class="form-control">
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group mb-3">
                                <label for="card_number">აგრობარათის ბოლო 4 ციფრი</label>
                                <input type="text" onkeypress="if(this.value.length == 4) return false" v-model="formData.card_number" id="card_number" class="form-control">
                            </div>
                        </div>
                        <div class="col-md-5">
                            <label for="product" class="mb-1">პროდუქტი</label>
                            <v-select id="product" :options="options" label="name" v-model="selectedProduct"></v-select>
                        </div>
                        <div class="col-md-4">
                            <label for="price" class="mb-1">ფასი</label>
                            <input type="number" id="price" class="form-control" v-model="product_price" @paste="onPaste">
                        </div>
                        <div class="col-md-3">
                            <label class="d-block">ქმედება</label>
                            <button type="button" class="btn btn-warning w-100" style="margin-top:7px" @click="addField">დამატება</button>
                        </div>

                        <table class="table table-bordered" v-if="formData.products.length > 0">
                            <thead>
                                <tr>
                                    <th>პროდუქტის დასახელება</th>
                                    <th>პროდუქტის ჯამური თანხა</th>
                                    <th>ქმედება</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, index) in formData.products" :key="index">
                                    <td>{{ item.name }}</td>
                                    <td>{{ item.product_price }}</td>
                                    <td>
                                        <button type="button" class="btn btn-danger w-100" data-bs-target="#confirmationModal" data-bs-toggle="modal" @click="setId(index)">წაშლა</button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                        <div class="col-md-12">
                            <label for="amount" class="d-block mb-2">ჯამური აგროქულა</label>
                            <input type="text" id="amount" class="form-control" v-model="formData.full_amount" @paste="onPaste" @keyup="replaceComma">
                            <span class="text-danger" v-if="pst">მონაცემი შეიყვანეთ ხელით!</span>
                        </div>

                        <div class="col-md-12">
                            <label class="d-block mb-2">ზედნადების ატვირთვა</label>
                            <file-pond
                                name="files"
                                label-idle="ატვირთეთ/ჩააგდეთ ფაილი აქ ..."
                                :acceptedFileTypes="['application/pdf']"
                                :server="{
                                    url : '',

                                    process : {
                                        url : 'https://nuts.rda.gov.ge/api/statement/file/upload',
                                        method : 'POST',
                                        onload : handle
                                    },

                                    revert : {
                                        url : 'https://nuts.rda.gov.ge/api/statement/file/delete'
                                    }
                                }"
                                v-bind:files="files"
                            />
                            <div v-for="(data, index) in files_details" :key="data.id">
                                <div class="container">
                                    <div class="d-flex justify-content-between align-items-center mt-2 rounded p-2 bg-dark bg-opacity-50 text-white">
                                        <span style="font-family: sans-serif">{{ data.name }}</span>
                                        <button class="times" type="button" :data-id="data.id" @click="deleteFile($event, index)">&times;</button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-12" v-if="permission != 'company'">
                            <div class="form-group mb-3">
                                <label for="personal_id">სტატუსი</label>
                                <select class="form-select" v-model="formData.status">
                                    <option value="" selected disabled>სტატუსი</option>
                                    <option value="active">აქტიური</option>
                                    <option value="inactive">არააქტიური</option>
                                    <option value="pending">pending</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-md-12" v-if="permission != 'company'">
                            <div class="form-group mb-3">
                                <label for="comment">კომენტარი</label>
                                <textarea class="form-control" id="comment" style="resize:none" v-model="formData.comment"></textarea>
                            </div>
                        </div>
                        <div class="col-md-12 mb-3">
                            <div class="d-grid">
                                <button type="submit" class="btn btn-success" :disabled="disabled">
                                    განაცხადის გადაგზავნა
                                    <span v-if="loader" class="spinner-border spinner-border-sm"></span>
                                </button>
                            </div>
                        </div>
                    </form>
                    <div v-for="(item, index) in errors" :key="index" class="alert alert-danger border-0">
                        <strong>{{ item[0] }}</strong>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal fade" id="confirmationModal">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">გთხოვთ დაადასტუროთ</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        ნამდვიად გსურთ წაშლა?
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">არა</button>
                        <button type="button" class="btn btn-danger" data-bs-dismiss="modal" @click="removeField">კი</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import axios, { AxiosError } from 'axios';
    import MyHeader from "../../components/Header.vue";
    import vSelect from "vue-select";
    import "vue-select/dist/vue-select.css"
    import FlatPickr from "vue-flatpickr-component";
    import 'flatpickr/dist/flatpickr.css';
    import vueFilePond from "vue-filepond";
    import "filepond/dist/filepond.min.css";

    export default {
        name : "StatementAdd",

        components : {
            MyHeader,
            "file-pond" : vueFilePond(),
            vSelect,
            FlatPickr
        },

        mounted() {
            document.title = "განაცხადის დამატება";

            axios.get("/products", {
                headers : {
                    "Authorization" : "Bearer " + JSON.parse(window.localStorage.getItem("token"))
                }
            }).then(response => {
                this.options = response.data;
            }).catch(err => {
                console.log(err);
            })
        },

        data() {
            return {
                user_id : JSON.parse(window.localStorage.getItem("user")).user_id,
                permission : JSON.parse(window.localStorage.getItem("user")).permission,

                disabled : false,
                loader : false,

                errors : [],

                options : [],

                selectedProduct : "",
                product_price : "",
                pst : 0,

                formData : {
                    overhead_number : "",
                    overhead_date : new Date(),
                    store_address : "",
                    full_amount : "",
                    beneficiary_name : "",
                    card_number : "",
                    comment : "",

                    products : [],
                    files : [],
                },

                id : "",
                
                files_details : [],

                flatpickrOptions: {
                    enableTime: false,
                    dateFormat: 'Y-m-d',
                },
            }
        },

        methods : {
            handle(response) {
                const _this_ = this;

                this.formData.files.push(JSON.parse(response).id);
                
                this.files_details.push({
                    id : JSON.parse(response).id,
                    name : JSON.parse(response).name,
                });
            },

            deleteFile($event, index) {
                const id = Number(event.target.getAttribute("data-id"));
                const _this_ = this;

                axios.get("/statement/file/delete/" + id, {
                    headers : {
                        "Authorization" : "Bearer " + JSON.parse(window.localStorage.getItem("token"))
                    }
                }).then(response => {
                    console.log(response.data);

                    _this_.files_details.splice(index, 1);
                    _this_.formData.files.splice(index, 1);
                }).catch(err => console.log(err));
            },

            addStatement() {
                this.disabled = true;
                this.loader = true;
                const _this_ = this;

                axios.post("/statement/add", this.formData, {
                    headers : {
                        "Authorization" : "Bearer " + JSON.parse(window.localStorage.getItem("token"))
                    }
                }).then(response => {
                    this.$swal({
                        title : "ზედნადები დაემატა",
                        icon : "success",
                    });

                    this.$refs.statement_form.reset();
                    this.disabled = false;
                    this.loader = false;

                    setTimeout(() => {
                        this.$router.back();
                    }, 1000);

                }).catch(err => {
                    if(err instanceof AxiosError) {
                        this.errors = err?.response?.data?.errors;
                    }

                    this.disabled = false;
                    this.loader = false;
                })
            },

            addField() {
                if(this.selectedProduct != "" && this.product_price != "") {
                    this.formData.products.push(
                        {
                            product_id : this.selectedProduct.id,
                            name : this.selectedProduct.name,
                            product_price : this.product_price
                        }
                    );
                }

                this.selectedProduct = "";
                this.product_price = "";
            },

            removeField() {
                this.formData.products.splice(this.id, 1);
            },

            setId(index) {
                this.id = index;
            },

            onPaste(event) {
                var _this_ = this;
                event.preventDefault();
                console.log('Pasting is disabled.');
                _this_.pst = 1;
            },

            replaceComma() {
                var _this_ = this;
                _this_.formData.full_amount = _this_.formData.full_amount.replace(',', '.');
            }
        }
    }
</script>

<style scoped>
    .times {
        width: 1.625em;
        height: 1.625em;
        background: rgba(0, 0, 0, 0.7);
        color: white;
        border-radius: 150px;
        outline: none;
        border: none;
        font-weight: bolder;
    }
</style>